import { VStack, Text } from "@gluestack-ui/themed";
import EmptyImage from "@repo/core/assets/images/empty-state.svg";

import { EmptyStateProps } from "./types";

export const EmptyState = ({
  height = "$100vh",
  flex,
  text = "Nenhum resultado\nencontrado"
}: EmptyStateProps) => {
  return (
    <VStack
      w="$full"
      flex={flex}
      // glustack not provide types for height
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      h={height as any}
      alignItems="center"
      gap="$4"
      justifyContent="center"
    >
      <EmptyImage />
      <Text
        color="$textLight600"
        textAlign="center"
        fontWeight={400}
        fontSize="$sm"
      >
        {text}
      </Text>
    </VStack>
  );
};
